import { Button } from '@/components/ui/button';
import { groupContacts } from './tenure';

export function ContactGroups({ people, mode, onSelect }) {
  const groups = groupContacts(people, mode).filter(group => group.complete && group.members.length > 1);
  return <section className="space-y-2 mb-4 rounded-lg border p-3" aria-label="Soggetti con recapito comune">
    <p className="font-medium text-sm">{mode === 'PEC' ? 'Soggetti con la stessa PEC' : 'Soggetti con lo stesso indirizzo per raccomandata'}</p>
    <p className="text-xs text-muted-foreground">Raggruppamento di consultazione. Soggetti, titolarità e invii restano individuali. Solo i recapiti completi e uguali vengono raggruppati.</p>
    {groups.length === 0 && <p className="text-sm text-muted-foreground">Nessun recapito condiviso tra i soggetti visualizzati.</p>}
    {groups.map(group => <details key={group.key} className="border rounded-md p-2" open>
      <summary className="cursor-pointer text-sm break-words">{group.label} · {group.members.length} soggetti</summary>
      <div className="flex flex-wrap gap-2 mt-2">{group.members.map(person =>
        <Button key={person.id} type="button" variant="outline" size="sm" onClick={() => onSelect(person)}>{person.full_name}</Button>
      )}</div>
    </details>)}
  </section>;
}
